import React from 'react';
import numeral from 'numeral';
import moment from 'moment';

import { attributionPlatform } from '../../config/filters';
import { getRangeFromDays } from '../../utils/dates';
import { Checkbox } from 'react-bootstrap';

export const config = {
  ATTRIBUTION_PLATFORM_PAGE_ID: 'attributionPlatform',
  ATTRIBUTION_PLATFORM_FILTERS: attributionPlatform
};

const getTitleType = titleType => {
  let type = '';
  if (titleType === 'movie') {
    type = 'Movie';
  } else if (titleType === 'series') {
    type = 'Show';
  }
  return type;
};

const onCheckboxChange = e => {
  // Get or instantiate current value
  var selectedTitles = JSON.parse(
    localStorage.getItem('attributionSelectedTitles')
  );
  if (!selectedTitles) {
    selectedTitles = [];
  }

  // Checked
  if (e.target.checked === true) {
    if (selectedTitles.indexOf(e.target.name) === -1) {
      selectedTitles.push(e.target.name);
    }
  }
  // Unchecked
  else {
    selectedTitles = selectedTitles.filter(item => item !== e.target.name);
  }

  // Set and trigger event
  localStorage.setItem(
    'attributionSelectedTitles',
    JSON.stringify(selectedTitles)
  );
  const event = new Event('attributionSelectedTitlesUpdated');
  document.dispatchEvent(event);
};

export const columns = [
  {
    Header: '',
    accessor: 'contentId',
    className: 'tvt-tabular-data-table__attributionplatform-id',
    Cell: ({ row: { original }, cell: { value } }) => {
      const selectedValues = JSON.parse(
        localStorage.getItem('attributionSelectedTitles')
      );
      const isChecked = selectedValues.includes(value);
      return (
        <>
          <Checkbox
            onChange={onCheckboxChange}
            name={value}
            defaultChecked={isChecked}
          />
        </>
      );
    }
  },
  {
    Header: 'Title',
    accessor: 'contentName',
    className: 'tvt-tabular-data-table__attributionplatform-title'
  },
  {
    Header: 'Content Type',
    accessor: 'contentType',
    className: 'tvt-tabular-data-table__attributionplatform-content_type',
    Cell: ({ row: { original }, cell: { value } }) => {
      return getTitleType(original.contentType);
    }
  },
  {
    Header: 'Release Date',
    accessor: 'releaseDate',
    className: 'tvt-tabular-data-table__attributionplatform-release_date',
    Cell: ({ row: { original }, cell: { value } }) =>
      value ? moment(value).format('MM/DD/YYYY') : 'Unknown'
  },
  {
    Header: 'Originating Network/Studio',
    accessor: 'networkName',
    className: 'tvt-tabular-data-table__attributionplatform-studio',
    Cell: ({ row: { original }, cell: { value } }) => {
      let name = '';
      if (original.networkName) {
        name = original.networkName;
      }
      if (original.studioName) {
        name =
          name.length > 0
            ? `${name} / ${original.studioName}`
            : original.studioName;
      }
      return name;
    }
  },
  {
    Header: 'Platform',
    accessor: 'platform',
    className: 'tvt-tabular-data-table__attributionplatform-platform'
  },
  {
    Header: 'Votes',
    accessor: 'voteCount',
    className: 'tvt-tabular-data-table__attributionplatform-votes',
    Cell: ({ row: { original }, cell: { value } }) => numeral(value).format(',')
  },
  {
    Header: '% Title Votes',
    accessor: 'titleVoteShare',
    className: 'tvt-tabular-data-table__attributionplatform-percent_title',
    Cell: ({ row: { original }, cell: { value } }) =>
      numeral(value / 100).format('0.00%')
  },
  {
    Header: '% Platform Votes',
    accessor: 'platformVoteShare',
    className: 'tvt-tabular-data-table__attributionplatform-percent_platform',
    Cell: ({ row: { original }, cell: { value } }) =>
      numeral(value / 100).format('0.00%')
  }
];

export const attributionFilters = {
  content: [
    {
      id: 'platform',
      label: 'Platform(s)',
      tooltip: 'Platform tooltip'
    },
    {
      id: 'contentType',
      label: 'Content Type',
      tooltip: '',
      value: []
    },
    {
      id: 'network',
      label: 'Network',
      tooltip: ''
    },
    {
      id: 'studio',
      label: 'Studio',
      tooltip: ''
    },
    {
      id: 'genre',
      label: 'Genre',
      tooltip: ''
    },

    {
      id: 'first_release_date',
      label: 'Release Date',
      isToggle: true,
      options: [
        { value: null, label: 'All Time' },
        { value: getRangeFromDays(30).value, label: 'Last 30 days' },
        { value: getRangeFromDays(60).value, label: 'Last 60 days' },
        { value: getRangeFromDays(90).value, label: 'Last 90 days' },
        { value: -1, label: 'Custom', id: 'custom-date' }
      ]
    },
    {
      id: 'report_date',
      label: 'Report Date',
      isToggle: true,
      options: [
        { value: null, label: 'All Time' },
        { value: getRangeFromDays(30).value, label: 'Last 30 days' },
        { value: getRangeFromDays(60).value, label: 'Last 60 days' },
        { value: getRangeFromDays(90).value, label: 'Last 90 days' },
        { value: -1, label: 'Custom', id: 'custom-date' }
      ]
    }
  ],
  demographic: [
    { id: 'age', label: 'Age Range' },
    { id: 'country', label: 'Region' },
    {
      id: 'gender',
      label: 'Gender',
      isToggle: true,
      options: [
        { value: null, label: 'All' },
        { value: 'female', label: 'Female' },
        { value: 'male', label: 'Male' }
      ]
    },
    {
      id: 'panel',
      label: 'Panel',
      isToggle: true,
      options: [
        { value: null, label: 'Total' },
        { value: 'Yes', label: 'Balanced' }
      ]
    }
  ]
};

export const defaultSorts = ['voteCount'];

export default { config, defaultSorts };
